import {i18n} from '@netx/core/i18n';

export const ProjectReviewsLabel = {
	ROUTE: i18n.t('i18n.reviews'),
};
